import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid #E0E0E0',
    fontSize: 14,
    borderRadius: '2px',
    maxWidth: '400px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.08)',
    fontWeight: 'normal',
    marginTop: '10px',
    marginLeft: '4px'
  }
}))(Tooltip);

export default LightTooltip;
